import React from 'react';
import { StyledTextDiv } from '../utils/reportUsage.styled';
import { setCurrencyFormat } from 'src/utils/util';

const DiscountedPriceTemplate = ({
    isFromReportScreen,
    originalPrice,
    adjustedPrice,
    modifiedPrice,
    textAlign,
    marginLeftRp,
    marginTopRp,
    marginRightRp,
    paddingTopRp,
    width,
    minWidth,
    priceWidth,
    priceContainerHeight,
    priceContainerAlignItem,
    priceContainerJustifyContent,
    isPriceNotAvailable,
    isIpadMargin
}) => {
    const getMarginLeft = () => {
        if (isFromReportScreen) return '50px';
        if (isIpadMargin && window.innerWidth >= 810 && window.innerWidth <= 1080) return '40px';
        if (marginLeftRp) return marginLeftRp;
        return '0px';
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: marginTopRp,
                marginLeft: getMarginLeft(),
                marginRight: marginRightRp,
                paddingTop: paddingTopRp,
                width: priceWidth,
                height: priceContainerHeight,
                alignItems: priceContainerAlignItem,
                justifyContent: priceContainerJustifyContent,
            }}
        >
            {!isPriceNotAvailable && adjustedPrice && (
                <StyledTextDiv
                    color={'#E5047E'}
                    fontSize={'14px'}
                    textAlign={textAlign ? textAlign : 'end'}
                    textDecoration={'line-through'}
                    fontFamily={'AvenirNextWorld Regular'}
                    marginRight={marginRightRp}
                >
                    {originalPrice}
                </StyledTextDiv>
            )}
            <StyledTextDiv
                color={isPriceNotAvailable ? '#ED002A' : '#202124'}
                fontSize={'14px'}
                textAlign={textAlign ? textAlign : 'end'}
                fontFamily={'AvenirNextWorld Regular'}
                width={width}
                minWidth={minWidth}
            >
                {isPriceNotAvailable
                    ? setCurrencyFormat(101.101, true, {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                      })
                          .replaceAll('1', '-')
                          .replaceAll('0', ' ')
                          .replace(',', ':')
                          .replace('.', ':')
                    : modifiedPrice}
            </StyledTextDiv>
        </div>
    );
};

export default DiscountedPriceTemplate;
